import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { bubbleStyles } from '../../data';

const blink = keyframes`
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

export const Dot = styled.span`
  margin: 0 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  animation: ${blink} 1.4s infinite;
`;

export const BubbleLoadingWrapper = styled.li`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  justify-content: center;
  min-width: auto;
  opacity: 0;
  transform: translateY(10px);
  animation: ${({ theme }) => theme.animation.bubble.show} 0.15s ease-out 0.3s both;

  ${({ theme }) => bubbleStyles({ theme, isSingleLine: true, isLoadingMessage: true })}

  ${Dot}:nth-of-type(1) {
    background-color: #82827f;
    animation-delay: 0s;
  }

  ${Dot}:nth-of-type(2) {
    background-color: #82827f;
    animation-delay: 0.2s;
  }

  ${Dot}:nth-of-type(3) {
    background-color: #d9d9d9;
    animation-delay: 0.4s;
  }
`;
